"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/** Global Class */
window.FAB_PLUGIN = Object.assign(Object.assign({}, window.FAB_PLUGIN), { 
    /**
     * Define Default Option
     * */
    defaultOptions: Object.assign(Object.assign({}, window.FAB_PLUGIN.defaultOptions), { select2: { placeholder: '--choose--' } }), 
    /** Page: Setting, Initiate Scripts */
    init_setting: () => {
        /** Initiate Select2 Setting */
        window.FAB_PLUGIN.init_setting_animation(); // Animation.
        window.FAB_PLUGIN.init_setting_design(); // Template.
        /** Initiate Select2 */
        jQuery('#setting-form .select2').select2();
        /** Initiate Color Picker */
        jQuery('.colorpicker').wpColorPicker();
        /** Trigger Section */
        jQuery(document).on('change.select2', '#setting-form .select2[name="field_option_animation_logo"]', window.FAB_PLUGIN.triggerSectionAnimateLogo);
        /** Trigger Others */
        window.FAB_PLUGIN.triggerOptionSettingValue();
        window.FAB_PLUGIN.triggerResetOptionButton();
    }, 
    /** Init Animation Setting */
    init_setting_animation: () => {
        /** Initiate Animation */
        jQuery('.field_option_animation_element').each(function () {
            /** Ignore Animation FAB */
            if (jQuery(this).attr('id') === 'field_option_animation_fab')
                return true;
            /** Set Animation */
            let animationDOM = jQuery(this);
            animationDOM.select2({
                data: window.FAB_PLUGIN.animateCSSAnimation,
            });
            let selected = animationDOM.data('selected');
            if (selected) {
                animationDOM.val(selected);
                animationDOM.trigger('change');
            }
        });
        /** Additional Animation FAB */
        let animationDOM = jQuery('#field_option_animation_fab');
        let data = [...window.FAB_PLUGIN.animateCSSAnimation];
        data.splice(1, 0, { id: 'ripple', text: 'Ripple' });
        animationDOM.select2({ data: data });
        let selected = animationDOM.data('selected');
        if (selected) {
            animationDOM.val(selected);
            animationDOM.trigger('change');
        }
    }, 
    /** Init Design Setting */
    init_setting_design: () => {
        /** Layout  Position */
        let dom = jQuery('#field_option_design_layout_position');
        dom.select2({
            placeholder: '--choose--',
            data: window.FAB_PLUGIN.defaultOptions.layout.position,
        });
        dom.val(dom.data('selected'));
        dom.trigger('change');
        /** Template Name */
        dom = jQuery('#field_option_design_template_name');
        dom.select2({
            placeholder: '--choose--',
            data: window.FAB_PLUGIN.defaultOptions.template.name,
        });
        dom.val(dom.data('selected'));
        dom.trigger('change');
        /** Template Name */
        dom = jQuery('#field_option_design_template_shape');
        dom.select2({
            placeholder: '--choose--',
            data: window.FAB_PLUGIN.defaultOptions.template.shape,
        });
        dom.val(dom.data('selected'));
        dom.trigger('change');
        /** Font Style */
        dom = jQuery('#field_option_design_font_style');
        dom.select2({
            placeholder: '--choose--',
            data: window.FAB_PLUGIN.defaultOptions.font.style,
        });
        dom.val(dom.data('selected'));
        dom.trigger('change');
        /** Sizing */
        dom = jQuery('#field_option_design_layout_position_margin_sizing');
        dom.select2({
            placeholder: '--choose--',
        });
        dom.val(dom.data('selected'));
        dom.trigger('change');
        dom = jQuery('#field_option_design_font_size_unit');
        dom.select2({
            placeholder: '--choose--',
        });
        dom.val(dom.data('selected'));
        dom.trigger('change');
        dom = jQuery('#field_option_design_font_padding_sizing');
        dom.select2({
            placeholder: '--choose--',
        });
        dom.val(dom.data('selected'));
        dom.trigger('change');
    }, 
    /** Handle Animated Logo, Section Change */
    triggerSectionAnimateLogo(el) {
        let value = el.target.value;
        jQuery('#setting-form .bg-cover-image img').attr('class', `animate__animated animate__${value}`);
    },
    /** Trigger Reset Option Value */
    triggerOptionSettingValue() {
        jQuery('.option_settings').change(function () {
            let key = jQuery(this).data('option'), val = (jQuery(this).is(':checked')) ? 1 : 0;
            jQuery(`#${key}`).val(val);
        });
    },
    /** Trigger Reset Option Button */
    triggerResetOptionButton() {
    }, 
    /**
     * Animate UI Component
     * @params     object      Selector object that would like to be animated
     * @params     string      Type of animation in a form of string class 'animated bounce'
     * */
    animate: (selector, animation) => {
        jQuery(selector).addClass(animation);
        jQuery(selector).on('animationend', () => { jQuery(selector).removeClass(animation); });
        return jQuery(selector);
    }, 
    /**
     * Convert given string into camel case
     * @params     string      String to be camelize
     * */
    camelize: (text, separator = "_") => {
        return text.split(separator)
            .map(w => w.replace(/./, m => m.toUpperCase()))
            .join();
    }, 
    /** Additional function for wpautop */
    _autop_newline_preservation_helper: (matches) => {
        return matches[0].replace("\n", "<WPPreserveNewline />");
    }, 
    /**
     * Check wether given string is valid
     * @params     string      String to be check
     * */
    isEmail: (email) => {
        let re = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        return re.test(email);
    }, 
    /** Check function is numeric */
    isNumeric: (str) => {
        if (typeof str !== "string") {
            return false;
        } // we only process strings!
        return !isNaN(str) && // use type coercion to parse the _entirety_ of the string (`parseFloat` alone does not do this)...
            !isNaN(parseFloat(str)); // ...and ensure strings of whitespace fail
    }, 
    /**
     * Validate form before submission
     * @params     object      Required form specs before it can be submitted
     * @params     object      Form object array containing values which will be validated
     * */
    validate_form: (specs, states) => {
        let validation = { status: true, message: '' };
        /** Setup Message function */
        const setupMessage = (fieldName, extras = '') => {
            let message = fieldName.split('_');
            message.splice(0, 1);
            message = window.FAB_PLUGIN.camelize(message.join('_')).replace(',', ' ');
            return message + extras;
        };
        /** Validation process */
        specs.required.some((spec) => {
            /** Locate Element */
            let element = { position: -1, value: '' };
            states.some((state, index) => {
                if (state.name === spec) {
                    element.position = index;
                    element.value = state.value;
                    return true;
                }
            });
            /** Validate required fields */
            if (element.position === -1 || !element.value) {
                validation.status = false;
                validation.message = (specs.messages && specs.messages[spec]) ? specs.messages[spec] :
                    setupMessage(spec, ' field is required!');
                return true;
            }
            /** Validate fields type */
            else if (specs.types && specs.types[spec]) {
                if (specs.types[spec] === 'email' && !window.FAB_PLUGIN.isEmail(element.value)) {
                    validation.status = false;
                    validation.message = (specs.messages && specs.messages[spec]) ? specs.messages[spec] :
                        setupMessage(spec, ` field is not valid! Please input valid email address!`);
                }
                else if (specs.types[spec] === 'integer' && !isNaN(parseInt(specs.types[spec]))) {
                    validation.status = false;
                    validation.message = (specs.messages && specs.messages[spec]) ? specs.messages[spec] :
                        setupMessage(spec, ` field is not valid! Please input valid integer number!`);
                }
                if (!validation.status) {
                    return true;
                }
            }
        });
        return validation;
    }, 
    /** Smooth Scroll To with Duration */
    scrollTo(element, to, duration) {
        let start = element.scrollTop, change = to - start, currentTime = 0, increment = 20;
        let easeInOutQuad = function (t, b, c, d) {
            t /= d / 2;
            if (t < 1)
                return c / 2 * t * t + b;
            t--;
            return -c / 2 * (t * (t - 2) - 1) + b;
        };
        let animateScroll = function () {
            currentTime += increment;
            const val = easeInOutQuad(currentTime, start, change, duration);
            element.scrollTop = val;
            if (currentTime < duration) {
                setTimeout(animateScroll, increment);
            }
        };
        animateScroll();
    }, 
    /** Animate CSS (https://animate.style/) - Animation */
    animateCSSAnimation: [
        { id: '', text: 'None' },
        {
            text: 'Attention Seekers',
            children: [
                { id: 'bounce', text: 'bounce' },
                { id: 'flash', text: 'flash' },
                { id: 'pulse', text: 'pulse' },
                { id: 'rubberBand', text: 'rubberBand' },
                { id: 'shakeX', text: 'shakeX' },
                { id: 'shakeY', text: 'shakeY' },
                { id: 'headShake', text: 'headShake' },
                { id: 'swing', text: 'swing' },
                { id: 'tada', text: 'tada' },
                { id: 'wobble', text: 'wobble' },
                { id: 'jello', text: 'jello' },
                { id: 'heartBeat', text: 'heartBeat' },
            ],
        },
        {
            text: 'Back entrances',
            children: [
                { id: 'backInDown', text: 'backInDown' },
                { id: 'backInLeft', text: 'backInLeft' },
                { id: 'backInRight', text: 'backInRight' },
                { id: 'backInUp', text: 'backInUp' },
            ],
        },
        {
            text: 'Back exits',
            children: [
                { id: 'backOutDown', text: 'backOutDown' },
                { id: 'backOutLeft', text: 'backOutLeft' },
                { id: 'backOutRight', text: 'backOutRight' },
                { id: 'backOutUp', text: 'backOutUp' },
            ],
        },
        {
            text: 'Bouncing entrances',
            children: [
                { id: 'bounceIn', text: 'bounceIn' },
                { id: 'bounceInDown', text: 'bounceInDown' },
                { id: 'bounceInLeft', text: 'bounceInLeft' },
                { id: 'bounceInRight', text: 'bounceInRight' },
                { id: 'bounceInUp', text: 'bounceInUp' },
            ],
        },
        {
            text: 'Bouncing exits',
            children: [
                { id: 'bounceOut', text: 'bounceOut' },
                { id: 'bounceOutDown', text: 'bounceOutDown' },
                { id: 'bounceOutLeft', text: 'bounceOutLeft' },
                { id: 'bounceOutRight', text: 'bounceOutRight' },
                { id: 'bounceOutUp', text: 'bounceOutUp' },
            ],
        },
        {
            text: 'Fading entrances',
            children: [
                { id: 'fadeIn', text: 'fadeIn' },
                { id: 'fadeInDown', text: 'fadeInDown' },
                { id: 'fadeInDownBig', text: 'fadeInDownBig' },
                { id: 'fadeInLeft', text: 'fadeInLeft' },
                { id: 'fadeInLeftBig', text: 'fadeInLeftBig' },
                { id: 'fadeInRight', text: 'fadeInRight' },
                { id: 'fadeInRightBig', text: 'fadeInRightBig' },
                { id: 'fadeInUp', text: 'fadeInUp' },
                { id: 'fadeInUpBig', text: 'fadeInUpBig' },
                { id: 'fadeInTopLeft', text: 'fadeInTopLeft' },
                { id: 'fadeInTopRight', text: 'fadeInTopRight' },
                { id: 'fadeInBottomLeft', text: 'fadeInBottomLeft' },
                { id: 'fadeInBottomRight', text: 'fadeInBottomRight' },
            ],
        },
        {
            text: 'Fading exits',
            children: [
                { id: 'fadeOut', text: 'fadeOut' },
                { id: 'fadeOutDown', text: 'fadeOutDown' },
                { id: 'fadeOutDownBig', text: 'fadeOutDownBig' },
                { id: 'fadeOutLeft', text: 'fadeOutLeft' },
                { id: 'fadeOutLeftBig', text: 'fadeOutLeftBig' },
                { id: 'fadeOutRight', text: 'fadeOutRight' },
                { id: 'fadeOutRightBig', text: 'fadeOutRightBig' },
                { id: 'fadeOutUp', text: 'fadeOutUp' },
                { id: 'fadeOutUpBig', text: 'fadeOutUpBig' },
                { id: 'fadeOutTopLeft', text: 'fadeOutTopLeft' },
                { id: 'fadeOutTopRight', text: 'fadeOutTopRight' },
                { id: 'fadeOutBottomRight', text: 'fadeOutBottomRight' },
                { id: 'fadeOutBottomLeft', text: 'fadeOutBottomLeft' },
            ],
        },
        {
            text: 'Flippers',
            children: [
                { id: 'flip', text: 'flip' },
                { id: 'flipInX', text: 'flipInX' },
                { id: 'flipInY', text: 'flipInY' },
                { id: 'flipOutX', text: 'flipOutX' },
                { id: 'flipOutY', text: 'flipOutY' },
            ],
        },
        {
            text: 'Lightspeed',
            children: [
                { id: 'lightSpeedInRight', text: 'lightSpeedInRight' },
                { id: 'lightSpeedInLeft', text: 'lightSpeedInLeft' },
                { id: 'lightSpeedOutRight', text: 'lightSpeedOutRight' },
                { id: 'lightSpeedOutLeft', text: 'lightSpeedOutLeft' },
            ],
        },
        {
            text: 'Rotating entrances',
            children: [
                { id: 'rotateIn', text: 'rotateIn' },
                { id: 'rotateInDownLeft', text: 'rotateInDownLeft' },
                { id: 'rotateInDownRight', text: 'rotateInDownRight' },
                { id: 'rotateInUpLeft', text: 'rotateInUpLeft' },
                { id: 'rotateInUpRight', text: 'rotateInUpRight' },
            ],
        },
        {
            text: 'Rotating exits',
            children: [
                { id: 'rotateOut', text: 'rotateOut' },
                { id: 'rotateOutDownLeft', text: 'rotateOutDownLeft' },
                { id: 'rotateOutDownRight', text: 'rotateOutDownRight' },
                { id: 'rotateOutUpLeft', text: 'rotateOutUpLeft' },
                { id: 'rotateOutUpRight', text: 'rotateOutUpRight' },
            ],
        },
        {
            text: 'Specials',
            children: [
                { id: 'hinge', text: 'hinge' },
                { id: 'jackInTheBox', text: 'jackInTheBox' },
                { id: 'rollIn', text: 'rollIn' },
                { id: 'rollOut', text: 'rollOut' },
            ],
        },
        {
            text: 'Zooming entrances',
            children: [
                { id: 'zoomIn', text: 'zoomIn' },
                { id: 'zoomInDown', text: 'zoomInDown' },
                { id: 'zoomInLeft', text: 'zoomInLeft' },
                { id: 'zoomInRight', text: 'zoomInRight' },
                { id: 'zoomInUp', text: 'zoomInUp' },
            ],
        },
        {
            text: 'Zooming exits',
            children: [
                { id: 'zoomOut', text: 'zoomOut' },
                { id: 'zoomOutDown', text: 'zoomOutDown' },
                { id: 'zoomOutLeft', text: 'zoomOutLeft' },
                { id: 'zoomOutRight', text: 'zoomOutRight' },
                { id: 'zoomOutUp', text: 'zoomOutUp' },
            ],
        },
        {
            text: 'Sliding entrances',
            children: [
                { id: 'slideInDown', text: 'slideInDown' },
                { id: 'slideInLeft', text: 'slideInLeft' },
                { id: 'slideInRight', text: 'slideInRight' },
                { id: 'slideInUp', text: 'slideInUp' },
            ],
        },
        {
            text: 'Sliding exits',
            children: [
                { id: 'slideOutDown', text: 'slideOutDown' },
                { id: 'slideOutLeft', text: 'slideOutLeft' },
                { id: 'slideOutRight', text: 'slideOutRight' },
                { id: 'slideOutUp', text: 'slideOutUp' },
            ],
        },
    ] });
